import React, { FC } from 'react'

import { useBreakpoint, Stack, Grid, Column } from '@components'

const DEFAULT_BREAKPOINT_ITEMS_PER_ROW = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  4: 4,
}

interface CardGridProps<T> {
  items: ReadonlyArray<T>
  renderItem: (item: T) => JSX.Element | null
  breakpointItemsPerRow?: typeof DEFAULT_BREAKPOINT_ITEMS_PER_ROW
}

export const CardGrid = <T extends any>({
  items,
  renderItem,
  breakpointItemsPerRow = DEFAULT_BREAKPOINT_ITEMS_PER_ROW,
}: CardGridProps<T>): React.ReactElement<any, any> => {
  const breakpoint = useBreakpoint()

  if (breakpoint === 0) {
    return <>{items.map((item) => renderItem(item))}</>
  }

  const itemGroups = items.reduce((memo, item, index) => {
    if (index % breakpointItemsPerRow[breakpoint] === 0) {
      memo.push([item])
    } else {
      memo[memo.length - 1].push(item)
    }

    return memo
  }, [] as Array<Array<T>>)

  return (
    <>
      {itemGroups.map((group, index) => {
        return (
          <Stack key={index}>
            <Grid gap={4}>
              {group.map((item, index) => {
                return <Column key={index}>{renderItem(item)}</Column>
              })}

              {Array.from({
                length: breakpointItemsPerRow[breakpoint] - group.length,
              }).map((_, index) => (
                <Column key={index + group.length} />
              ))}
            </Grid>
          </Stack>
        )
      })}
    </>
  )
}
